<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Quality Control - Account Contact Requests Campaigns</h3>
        </vs-col>

        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">


        </vs-col>
      </vs-row>
  

        <ClientDataGrid :context="'campaignsListQC'" :columnDefs="campaignsColumnDefs" :rowData="campaignsRecords"
        @goToReviewQualityControlPage="goToReviewQualityControlPage">
      </ClientDataGrid>


    </vx-card>

>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    companySearchComponentKey: 0,

    user_id: null,
    user_role: null,

    abilities: null,
    campaignsColumnDefs: [
      // {
      //   headerName: "Actions",
      //   field: "transactions",
      //   cellRenderer: "CellRendererActions",
      //   suppressHeaderMenuButton: true,
      //   pinned: true,
      //   width: 80
      // },
      {
        headerName: "Campaign",
        field: "camp_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Client",
        field: "client_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      // {
      //   headerName: "Grade Changed",
      //   field: "grade_changed",
      //   flex: 1,
      //   filter: "agTextColumnFilter",
      //   filterParams: {
      //     buttons: ["apply", "reset"],
      //     maxNumConditions: 4
      //   }
      // },
    ],
    campaignsRecords: null,
    selected_campaign: null,
    selected_autocomplete_campaign:null,
  }),
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
    ClientDataGrid
  },
  watch: {},
  methods: {
    goToReviewQualityControlPage(data) {
      this.$router.push({
        path: "/quality_control/account_contact_requests/review_data/" + data.campaign_id + '/' + btoa(data.campaign_name)
      });
    },
    getcampaignDataSource() {
      var self = this;

      let data = {};
      data.selected_autocomplete_campaign = self.selected_autocomplete_campaign;
      self.$store
        .dispatch("campaignsManagement/getAllCampaignsForAccountContactRequests", data)
        .then(function(response) {

          let response_data = JSON.parse(response.data);

       
          self.campaignsRecords = response_data;


        })
        .catch(err => {
          console.error(err);
        });


    },
    // getcampaignDataSource() {
    //   var self = this;

    //   this.campaignsDataSource = {
    //     getRows(params) {
    //        params.request.selected_autocomplete_campaign = self.selected_autocomplete_campaign;
    //       self.$store
    //         .dispatch(
    //           "campaignsManagement/getAllCampaignsForReviewCampaignResultsGrid",
    //           params.request
    //         )
    //         .then(function (response) {
    //           let response_data = response.rows;

    //           console.log(response_data)
    //           if(response_data){
    //              if (response_data.length != 0) {
    //             self.$refs.campaignsListQC.gridApi.hideOverlay();
    //             params.success({ rowData: response.rows , rowCount: response.lastRow })
    //           } else {
    //             self.$refs.campaignsListQC.gridApi.showNoRowsOverlay();
    //             return params.success({ rowData: [] })
    //           }

    //           }
             
    //         })
    //         .catch(err => {
    //           console.error(err);
    //         });
    //     }
    //   };
    // },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    // this.getcampaignDataSource();
  },
  mounted() {

    this.getcampaignDataSource();
   },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
